import counterUp from 'counterup2'
// import Vue from 'vue'

// eslint-disable-next-line no-undef
$(document).ready(function(){
    require( 'waypoints/lib/noframework.waypoints.js' );

    const el = document.querySelector( '.counter' );
    // eslint-disable-next-line no-undef
    new Waypoint( {
        element: el,
        handler: function() {
            counterUp( el ) ;
            this.destroy()
        },
        offset: 'bottom-in-view',
    } );

    // Initializing Wow.js
    window.wow.init();

    // eslint-disable-next-line no-undef
    $('.js-signup').click(function(){
        this.$router.push({name: 'SignUp'})
    })

});